<script>
  // M3 basic dialog: 28px corner, surface-container-high, scrim backdrop,
  // title (24sp) + supporting text + 2 trailing text buttons. Esc / scrim
  // click cancels. Confirm button uses the error palette when destructive.
  import { ui } from '../lib/ui.svelte.js';

  function onKey(e) {
    if (!ui.confirm) return;
    if (e.key === 'Escape') { e.preventDefault(); ui.resolveConfirm(false); }
    else if (e.key === 'Enter') { e.preventDefault(); ui.resolveConfirm(true); }
  }
</script>

<svelte:window onkeydown={onKey} />

{#if ui.confirm}
  <div class="dlg-scrim" onclick={() => ui.resolveConfirm(false)} role="presentation"></div>
  <div class="dlg-wrap" role="dialog" aria-modal="true" aria-labelledby="dlg-title">
    <div class="dlg">
      <h2 id="dlg-title" class="dlg-title">{ui.confirm.title}</h2>
      {#if ui.confirm.message}
        <p class="dlg-body">{ui.confirm.message}</p>
      {/if}
      <div class="dlg-actions">
        <button class="dlg-btn" onclick={() => ui.resolveConfirm(false)}>
          {ui.confirm.cancelText}
        </button>
        <button class="dlg-btn" class:destructive={ui.confirm.destructive} onclick={() => ui.resolveConfirm(true)} autofocus>
          {ui.confirm.confirmText}
        </button>
      </div>
    </div>
  </div>
{/if}

<style>
  .dlg-scrim {
    position: fixed;
    inset: 0;
    background: rgb(0 0 0 / 0.32);
    z-index: 1200;
    animation: scrim-in 180ms ease-out;
  }
  .dlg-wrap {
    position: fixed;
    inset: 0;
    z-index: 1201;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    pointer-events: none;
  }
  .dlg {
    pointer-events: auto;
    width: 100%;
    max-width: 420px;
    background: rgb(var(--md-sys-color-surface-container-high));
    color: rgb(var(--md-sys-color-on-surface));
    border-radius: 28px;
    padding: 24px;
    box-shadow:
      0 6px 10px 0 rgba(0,0,0,0.30),
      0 12px 24px 8px rgba(0,0,0,0.15);
    animation: dlg-in 220ms cubic-bezier(.2,.0,0,1);
  }
  .dlg-title {
    font-size: 24px;
    line-height: 32px;
    font-weight: 400;
    margin: 0 0 16px 0;
  }
  .dlg-body {
    font-size: 14px;
    line-height: 20px;
    color: rgb(var(--md-sys-color-on-surface-variant));
    margin: 0 0 24px 0;
  }
  .dlg-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }
  .dlg-btn {
    height: 40px;
    padding: 0 12px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 500;
    color: rgb(var(--md-sys-color-primary));
    background: transparent;
    cursor: pointer;
  }
  .dlg-btn:hover {
    background: rgb(var(--md-sys-color-primary) / 0.08);
  }
  .dlg-btn.destructive { color: rgb(var(--md-sys-color-error)); }
  .dlg-btn.destructive:hover {
    background: rgb(var(--md-sys-color-error) / 0.08);
  }

  @keyframes scrim-in { from { opacity: 0; } to { opacity: 1; } }
  @keyframes dlg-in {
    from { opacity: 0; transform: scale(0.96); }
    to   { opacity: 1; transform: scale(1); }
  }
</style>
